import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../../catalog/config/component.config';

export namespace NCmsBlogComponentImageWithCopy {
    export const ID = 'image-with-copy';

    export interface IData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        component_width?: 'full' | 'fixed';
        image?: string;
        image_ratio: string;
        copy?: string;
        copy_style?: string;
        url?: string;
        title: string;
        title_style?: string;
        horizontal_text_align?: string;
        vertical_text_align?: string;
    }
}
